<script>
import {
  shippingMethodOverviewProps,
  useShippingMethodOverview
} from "./mixin";
import Card from "@/components/molecules/card";
import Icon from "@/components/atoms/icon";
import LinkTo from "@/components/atoms/link-to";

export default {
  name: "ShippingMethodOverview",
  components: { Card, Icon, LinkTo },
  props: {
    ...shippingMethodOverviewProps()
  },
  setup(props) {
    const { iconName } = useShippingMethodOverview(props);
    return { iconName };
  }
};
</script>

<template>
  <Card
    class="c-shipping-method c-shipping-method--overview"
    radius="md"
  >
    <div class="c-shipping-method__selector">
      <!-- TODO : composant image -->
      <div class="c-shipping-method__title">
        <Icon
          class="c-shipping-method__icon"
          :name="iconName"
        />
        <p class="c-shipping-method__label">
          {{ service.label }}
        </p>
      </div>
      <p class="c-shipping-method__time">
        {{ dateRetrait }}
        <LinkTo
          :to="{ path: './', query: { type_panier: typePanier }}"
          class="u-ml-md"
        >
          {{ service.type === 'CC'? "Revoir" : "Modifier" }}
        </LinkTo>
      </p>
      <p class="c-shipping-method__cost">
        {{ tarif }}
      </p>
    </div>
  </Card>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/shipping-method.scss";
</style>
